import { httpRequest } from '@/apis/request'

enum Apis {
  getDoorWallAio = 'door_wall_aio_setting',
  saveDoorWallAio = 'door_wall_aio_setting',
  getDoorWallAioList = 'door_wall_aio_list',
  load_door_wall_aio_model = 'door_wall_aio_model',
}

export function getDoorWallAioSetting(params: { setting_id: number }) {
  return httpRequest.get(Apis.getDoorWallAio, params)
}

export function saveDoorWallAioSetting(params: any) {
  return httpRequest.post(Apis.saveDoorWallAio, params)
}

export function getDoorWallAioList(params: any) {
  return httpRequest.get(Apis.getDoorWallAioList, params)
}

export function getLoadDoorWallAioModel(params: any) {
  return httpRequest.get(Apis.load_door_wall_aio_model, params)
}
